import { render, staticRenderFns } from "./MensalidadesLista.vue?vue&type=template&id=bd031a0c"
import script from "./MensalidadesLista.vue?vue&type=script&lang=js"
export * from "./MensalidadesLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports